import axios from 'axios';
import { QUALITY_SERVICE_API_URL } from './config'; // eslint-disable-line no-unused-vars
import oktaAuth from './auth/oktaAuth';

const api = axios.create();

api.interceptors.request.use(async (config) => {
  const token = await oktaAuth.getOrRenewAccessToken();
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const redirect = window.location.pathname + window.location.search;
      oktaAuth.signInWithRedirect({ originalUri: redirect });
    }
    return Promise.reject(error);
  }
);

export default api;
